export const AGENT_CLOSE_EVENT = "AGENT_CLOSE_EVENT";
export const AGENT_PING_EVENT = "AGENT_PING_EVENT";
export const AGENT_CONNECTION_READY = "AGENT_CONNECTION_READY";
